import { useEffect, useMemo, useState } from 'react'
import useOrbitAnimationDetails from '../../../hooks/useOrbitAnimationDetails'
import './OrbitAnimationTimeline.scss'
import { onSatelliteUpdate } from '../../../utils/viewer-packets'
import { truncateNumber } from '../../../../../../utils/commonFunctions'
import { AxisControlSvg, ExpandSvg } from '../../../../../CommonComponents/svgs/Svgs'
import CustomToolTip from '../../../../../CommonComponents/CustomToolTip'

const OrbitAnimationTimeline = () => {
    const { orbitAnimationDetails, onAxisControlChange, setOrbitAnimationDetails } = useOrbitAnimationDetails()
    const [coords, setCoords] = useState({ latitude: 0, longitude: 0, altitude: 0, heading: 0, pitch: 0, roll: 0 });

    const showAnimationDetails = useMemo(() => orbitAnimationDetails.showAnimationDetails, [orbitAnimationDetails.showAnimationDetails])
    const expandedView = useMemo(() => orbitAnimationDetails.expandedView, [orbitAnimationDetails.expandedView])
    const showAxisControl = useMemo(() => orbitAnimationDetails.showAxisControl, [orbitAnimationDetails.showAxisControl])

    useEffect(() => {
        const liveSatelliteData = onSatelliteUpdate((data) => {
            setCoords({ latitude: data.lat, longitude: data.lon, altitude: data.alt, heading: data.heading, pitch: data.pitch, roll: data.roll });
        });
        return liveSatelliteData;
    }, []);

    const onExpandChange = () => {
        setOrbitAnimationDetails((prev) => ({ ...prev, expandedView: !prev.expandedView }));
    }


    if (!showAnimationDetails) return null
    return (
        <div className='orbit__animation__timeline__container'>
            <div className='orbit__animation__timeline__left__container'>
                <div className='timeline__information__container'>
                    <span className='information__label'>Lat</span>
                    <span className='information__value'>{Math.round(coords.latitude * 100) / 100}</span>
                </div>
                <div className='timeline__information__container'>
                    <span className='information__label'>Long</span>
                    <span className='information__value'>{Math.round(coords.longitude * 100) / 100}</span>
                </div>
                <div className='timeline__information__container'>
                    <span className='information__label'>Altitude</span>
                    <span className='information__value'>{truncateNumber(coords.altitude, 2)}</span>
                </div>
                {/* <div className='timeline__information__container'>
                    <span className='information__label'>Roll</span>
                    <span className='information__value'>{Math.round(coords.roll * 100) / 100}</span>
                </div>
                <div className='timeline__information__container'>
                    <span className='information__label'>Pitch</span>
                    <span className='information__value'>{Math.round(coords.pitch * 100) / 100}</span>
                </div>
                <div className='timeline__information__container'>
                    <span className='information__label'>Yaw</span>
                    <span className='information__value'>{Math.round(coords.heading * 100) / 100}</span>
                </div> */}
            </div>
            <div className='orbit__animation__timeline__right__container'>
                <CustomToolTip title='Toggle Axis Control'>
                    <button className={`right__container__button ${showAxisControl && 'active'}`}
                        onClick={onAxisControlChange}
                    >
                        <AxisControlSvg />
                    </button>
                </CustomToolTip>
                <CustomToolTip title='Toggle Expanded View'>
                    <button className={`right__container__button ${expandedView && 'active'}`}
                        onClick={onExpandChange}
                    >
                        <ExpandSvg expanded={expandedView} />
                    </button>
                </CustomToolTip>
            </div>
        </div>
    )
}

export default OrbitAnimationTimeline